import React, { useEffect, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { loadModules } from "esri-loader";
import { UrlServices, UrlServicesTypeTrasnporte, UrlServicesTypeTrasnporteName, UrlServicesNode, UrlServicesfilterNode, createRequestURLs } from "../../../../.config";
import dateFormat from "dateformat";
import { BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import { RiCheckboxCircleFill } from "react-icons/ri";
import Button from 'react-bootstrap/Button';
import { TODIS_FORM_FIELD_MULTISELECT, TODIS_FORM_FIELD_TEXT, TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD, TODIS_FORM_DSC, TODIS_FORM_FIELD_DATE, TODIS_FORM_FIELD_DATE_YEAR, TODIS_FORM_FIELD_DATE_RQ, TODIS_FORM_FIELD_OPTIONS_GDB, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE } from "../../../../components/Forms";
import { AuxiliaryService } from '../../../../HttpService/AuxiliaryService';
import { Formik, Field, Form, ErrorMessage, useFormik } from 'formik';
import "../../../DataCollection/style.css";
import { TODIS_MODAL } from "../../../../components/Modals/Modal";
import { TODIS_TASK, TASK, RW_MARKET_MON, TODIS_RW_MARKET_MON } from "../../../../.config/form/network_performance";
import style from "../Requests.module.scss";
import { RequestService } from "../../../../HttpService/RequestService";
// import { loadModules } from "esri-loader";

const RwMaketMonRequest = (props) => {

    const [regionals, setRegionals] = useState([]);

    const [personals, setPersonals] = useState([
        {
            idAuxtabledetail: "john.doe",
            txtDescription: "John Doe"
        }
    ]);

    const [rwMarketMon, setRwMarketMon] = useState([]);


    const getDataSelect = async () => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/rwmarketmon,regionalpartner").getAuxiliaries();

            auxiliaries.map(item => {
                if (item.txtNameTable == "regionalpartner") {
                    let list = item.auxtableDetailsDTOList.sort((a, b) =>
                        a.txtDescription.localeCompare(b.txtDescription));
                    setRegionals(list)
                }
                if (item.txtNameTable == "rwmarketmon")
                    setRwMarketMon(item.auxtableDetailsDTOList)

            })

            getRegionalUsers();
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRegionalUsers = async () => {

        let users = await new RequestService("workflow/request/regionals").get();
        console.log('loaded users', users);
        let persons = users.map((itm) => {
            return {
                "idAuxtabledetail": itm.username,
                "txtDescription": itm.first_name + " " + itm.last_name
            }
        });
        //console.log("persons data", persons)
        if (users)
            setPersonals(persons);
    }


    useEffect(() => {
        getDataSelect();
    }, []);

    const [modalShow, setModalShow] = useState(false);




    const onSubmit = async (values, { resetForm }) => {

        try {
            let validFor = values.validFrom.year.toString();
            console.log("data Form", values);
            let regionalPartners = values.regionalPartnar.map((partner) => { return partner.value })
            const res = await new RequestService("workflow/request/rwmarketmon").createRequest({ ...values, regionalPartnar: regionalPartners, validFrom: validFor });
            //const res = await new RequestService("workflow/request").createRequest({ ...values, name: "Data Collection" });
            if (res.status > 200 && res.status < 300) {
                resetForm();
                props.onHide()
                props.pushRequest()
                setModalShow(true);
            } else {
                console.log("error in create Task", res);
            }
        } catch (error) {
            console.log("error in create Task", error);
        }
    }
    return (
        <Container fluid className="todis-form-wrapper p-3" style={{ height: "100%" }}>
            <Row>
                <Formik
                    initialValues={RW_MARKET_MON}
                    validationSchema={TODIS_RW_MARKET_MON}
                    onSubmit={onSubmit}>
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form className="todis-form-content p-0">
                            <Container>
                                <Row>

                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_MULTISELECT id="regionalPartnar" label="REGIONAL PARTNER" name="regionalPartnar" setFieldValue={setFieldValue} values={values} isLoading={false} options={regionals} />
                                        {errors.regionalPartnar && touched.regionalPartnar ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.regionalPartnar}</div>) : null}
                                    </Col>
                                    {/* <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="assignedTo" label="ASSIGNED TO" name="assignedTo" type="select" options={personals} />
                                        {errors.assignedTo && touched.assignedTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.assignedTo}</div>) : null}
                                    </Col> */}
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_DATE_YEAR id="validFrom" label="YEAR" name="validFrom" setFieldValue={setFieldValue} />
                                        {errors.validFrom && touched.validFrom ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validFrom}</div>) : null}
                                    </Col>
                                    <Col lg={12}>
                                        <TODIS_FORM_DSC id="description" label="DESCRIPTION" name="description" text="" style={{ height: "auto" }}></TODIS_FORM_DSC>
                                        {errors.description && touched.description ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.description}</div>) : null}
                                    </Col>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{ margin: "0.5rem" }}><BsPlusLg className="me-3" />CREATE REQUEST </Button>
                                    </div>
                                </Row>
                            </Container>
                            <TODIS_MODAL show={modalShow} onHide={() => setModalShow(false)} title="Creating Task" bodyText="Task has been created" iconBody={RiCheckboxCircleFill} />
                        </Form>
                    )}
                </Formik>
            </Row>
        </Container>
    );
}

export default RwMaketMonRequest;